import { RequestState } from '@shs-digi-care-monorepo/interfaces';

export const statusColorMap: Record<RequestState, string> = {
    [RequestState.SAVED]: 'bg-[#F9A825] text-black',
    [RequestState.SUBMITTED]: 'bg-[#ec6602] text-black',
    [RequestState.UNDER_REVIEW]: 'bg-[#3abfed] text-black',
    [RequestState.CLOSED]: 'bg-[#009a38] text-black',
    [RequestState.PENDING_CUSTOMER_ACTION]: 'bg-[#2b2483] text-white',
    [RequestState.REFERRED_OUT]: 'bg-[#009999] text-black'
};

export const statusPillColorMap: Record<RequestState, string> = {
    [RequestState.SAVED]: '#F9A825',
    [RequestState.SUBMITTED]: '#ec6602',
    [RequestState.UNDER_REVIEW]: '#3abfed',
    [RequestState.CLOSED]: '#009a38',
    [RequestState.PENDING_CUSTOMER_ACTION]: '#2b2483',
    [RequestState.REFERRED_OUT]: '#009999'
};
